module.exports = __webpack_public_path__ + "static/office-d75cb035263fb3346b2048680cd6cc9a.jpg";